var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8744 9.62889C12.8955 9.62889 11.9486 9.47333 11.0652 9.19333C10.7867 9.1 10.4763 9.17 10.2615 9.38L9.01206 10.9122C6.75996 9.86222 4.6511 7.87889 3.52903 5.6L5.08083 4.30889C5.2957 4.09111 5.35936 3.78778 5.27182 3.51556C4.97738 2.65222 4.82618 1.72667 4.82618 0.77C4.82618 0.35 4.46807 0 4.03834 0H1.28489C0.855158 0 0.337891 0.186667 0.337891 0.77C0.337891 7.99556 6.48939 14 13.8744 14C14.4394 14 14.6622 13.51 14.6622 13.0822V10.3989C14.6622 9.97889 14.3041 9.62889 13.8744 9.62889Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactPhone);
export default __webpack_public_path__ + "static/media/ContactPhone.6f4644f86260528ab0506eb992debc5d.svg";
export { ForwardRef as ReactComponent };